import { Component } from "react";
import moment from 'moment';
import {Form, Button, Row, Col} from 'react-bootstrap';
import {getAllUniversities, getAllCountries} from '../../services/opportunityService';
// import {getCountries} from '../../services/userMandatoryFields';
import { USER_DATA, ACADEMIC_PLANNING_YEARS_MORE, ACADEMIC_STUDY_GAP_IN_YEARS } from "../../helpers/constants";
import {DIPLOMES, SECTORS, INSTITUTE_CITY, GRADE, GRADE_SCALE} from "../../helpers/dummies";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {postUserAcademicInformation, postUserDocUpload, getUserAcademicInformation} from '../../services/userInformation';
import { toast } from 'react-toastify';
import { WEBSITE_URL } from "../../services/baseService";
import UserProfileBanner from "./UserProfileBanner";

class UserAcademicInformation extends Component {
    constructor(props) {
        super(props);
        this.state = {
            userData:[],
            currentUser:[],

            academic_planning_year:ACADEMIC_PLANNING_YEARS_MORE,
            academic_study_gap_year:ACADEMIC_STUDY_GAP_IN_YEARS,
            academic_level:DIPLOMES,
            academic_programme:SECTORS,
            academic_main_domain:SECTORS,
            academic_sceondary_domain:SECTORS,
            getAllUniversity: [],
            institute_city:INSTITUTE_CITY,
            getAllCountry:[],
            grade:GRADE,
            grade_scored:GRADE_SCALE,
            
            userAcademicInformation:[
                {
                    id:'',
                    publicId:'',
                    academic_objective:'',
                    academic_gap_in_last_study_in_years:'',
                    academic_planning_for_how_many_years_more:'',
                    academic_is_finished:'',
                    academic_level:'',
                    academic_last_program_name:'',
                    academic_main_domain:'',
                    academic_sceondary_domain:'',
                    academic_last_institute_name:'',
                    academic_last_institute_website:'',
                    academic_last_institute_city:'',
                    academic_last_institute_country_id:'',
                    academic_finalize:'',
                    academic_finalize_year:'',
                    academic_finalize_date:new Date(),
                    academic_grade_scale:'',
                    academic_grade_scored:'',
                    academic_final_aim:'',
                    academic_attach_file:'',
                    academic_attach_extra_certificate:'',
                    academic_attach_file_path:'',
                    academic_attach_extra_certificate_path:'',
                    enable_extra_certificates: false,
                    uploadedDocumentStatusAttach:'',
                    uploadedDocumentStatusExtraAttach:'',
                }
            ]
        }
        this.getAllUniversity = this.getAllUniversity.bind(this);
        this.getAllCountry = this.getAllCountry.bind(this);
        this.onChangeFields = this.onChangeFields.bind(this);
        this.appendFields = this.appendFields.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.uploadUserDocuments = this.uploadUserDocuments.bind(this);
        this.dateChange = this.dateChange.bind(this);
        this.getCurrentUserAcademicInformation = this.getCurrentUserAcademicInformation.bind(this);
        this.removeDocument = this.removeDocument.bind(this);
    }
    
    onChangeFields(e, index){
        let {name, value, checked} = e.target;
        if(name=="enable_extra_certificates") {
            console.log(checked, value, 'this is checked')
            // if(checked == true) {
                this.state.userAcademicInformation[index][name] = checked
                this.setState({userAcademicInformation:[...this.state.userAcademicInformation]})
            // } 
            // else {
            //     this.state.userAcademicInformation[index][name] = checked;
            //     this.setState({userAcademicInformation:[...this.state.userAcademicInformation]})
            // }
        }
        if(name=="academic_attach_extra_certificate") {
            this.state.userAcademicInformation[index][name]=e.target.files[0]?.name;
            this.setState({userAcademicInformation:[...this.state.userAcademicInformation]})
        }
        if(name == "academic_attach_file") {
            this.state.userAcademicInformation[index][name]=e.target.files[0]?.name;
            this.setState({userAcademicInformation:[...this.state.userAcademicInformation]})
        }
        if(name.startsWith("academic_is_finished_")) {
            let text = "academic_is_finished_";
            let new_index = name.replace(text, '');
            if(index == new_index) {
                this.state.userAcademicInformation[index]['academic_is_finished']=value;
                this.setState({userAcademicInformation:[...this.state.userAcademicInformation]})
            }
        }
        else {
            this.state.userAcademicInformation[index][name]=value;
            this.setState({userAcademicInformation:[...this.state.userAcademicInformation]})
        }
    }

    dateChange(date, index) {
        this.state.userAcademicInformation[index]['academic_finalize_date']=date;
        this.setState({userAcademicInformation:[...this.state.userAcademicInformation]})
    }

    appendFields() {
        let newFields =  {
            id:'',
            publicId:this.state.currentUser?.publicId,
            academic_objective:'',
            academic_gap_in_last_study_in_years:'',
            academic_planning_for_how_many_years_more:'',
            academic_is_finished:'',
            academic_level:'',
            academic_last_program_name:'',
            academic_main_domain:'',
            academic_sceondary_domain:'',
            academic_last_institute_name:'',
            academic_last_institute_website:'',
            academic_last_institute_city:'',
            academic_last_institute_country_id:'',
            academic_finalize:'',
            academic_finalize_year:'',
            academic_finalize_date:new Date(),
            academic_grade_scale:'',
            academic_grade_scored:'',
            academic_final_aim:'',
            academic_attach_file:'',
            academic_attach_extra_certificate:'',
            enable_extra_certificates: false,
            uploadedDocumentStatusAttach:'',
            uploadedDocumentStatusExtraAttach:'',
        };
        this.setState({userAcademicInformation:[...this.state.userAcademicInformation, {...newFields}]});
    }

    uploadUserDocuments(e, index) {
        let {name} = e.target;
        let formData = new FormData();
        formData.append('userPublicId', this.state.currentUser?.publicId);

        if(name == "academic_attach_file") {

            formData.append('academic_attach_file', e.target.files[0])
            this.setState({academic_attach_file:e.target.files[0]})
            if(e.target.files[0]) {
                postUserDocUpload(formData).then(response=>{
                    console.log(response, 'this is the response')
                    if(response && response?.message) {
                        this.state.userAcademicInformation[index]['uploadedDocumentStatusAttach']=response;
                        this.setState({userAcademicInformation:[...this.state.userAcademicInformation]})
                    } 
                    if(response && response?.academic_attach_file) {
                        this.state.userAcademicInformation[index]['uploadedDocumentStatusAttach']='';
                        this.state.userAcademicInformation[index]['academic_attach_file']=response?.academic_attach_file;
                        this.setState({userAcademicInformation:[...this.state.userAcademicInformation]})
                    }
                    if(response && response?.academic_attach_extra_certificate) {
                        this.state.userAcademicInformation[index]['uploadedDocumentStatusAttach']='';
                        this.state.userAcademicInformation[index]['academic_attach_extra_certificate']=response?.academic_attach_extra_certificate;
                        this.setState({userAcademicInformation:[...this.state.userAcademicInformation]})
                    }
                }).catch(error=>console.log(error, 'this is the error'));
            }
        }
        else {
            formData.append('academic_attach_extra_certificate', e.target.files[0])
            this.setState({academic_attach_extra_certificate:e.target.files[0]})
            if(e.target.files[0]) {
                postUserDocUpload(formData).then(response=>{
                    if(response && response?.message) {
                        this.state.userAcademicInformation[index]['uploadedDocumentStatusExtraAttach']=response;
                        this.setState({userAcademicInformation:[...this.state.userAcademicInformation]})
                    } 
                    if(response && response?.academic_attach_file) {
                        this.state.userAcademicInformation[index]['uploadedDocumentStatusExtraAttach']='';
                        this.state.userAcademicInformation[index]['academic_attach_file']=response?.academic_attach_file;
                        this.setState({userAcademicInformation:[...this.state.userAcademicInformation]})
                    }
                    if(response && response?.academic_attach_extra_certificate) {
                        this.state.userAcademicInformation[index]['uploadedDocumentStatusExtraAttach']='';
                        this.state.userAcademicInformation[index]['academic_attach_extra_certificate']=response?.academic_attach_extra_certificate;
                        this.setState({userAcademicInformation:[...this.state.userAcademicInformation]})
                    }
                }).catch(error=>console.log(error, 'this is the error'));
            }
        }

    }

    getAllUniversity() {
        getAllUniversities().then(response=>this.setState({getAllUniversity:response?.universities})).catch(error=>console.log(error, 'this is new error'));
    }

    getAllCountry() {
        getAllCountries().then(response=>this.setState({getAllCountry:response})).catch(error=>console.log(error, 'this is new error'));
    }

    onSubmit(e) {
        e.preventDefault();
        // console.log(this.state.userAcademicInformation, 'submit')
        let data = this.state.userAcademicInformation;
        postUserAcademicInformation(data).then(response=> {
            if(response) {
                toast.success("Academic Information Saved Successfully");
                setTimeout(()=>{
                    this.props.history.push("/user-professional-information");
                },1000)
            }
            else {
                 toast.error("There is an error, kindly check.")
            }
        }).catch(error=>console.log(error, 'this is new error'))
    }

    getCurrentUserAcademicInformation(userPublicId) {
        getUserAcademicInformation(userPublicId).then(response=>{
            // response && response?.length >0 && response?.map(data=>{
            //     if(data?.academic_attach_extra_certificate != "") {
            //         data['enable_extra_certificates']='true';
            //     }
            // })
            // this.setState({userAcademicInformation:response})
            this.setState({userAcademicInformation:response.length >0 ? response
                 :
                [{
                    id:'',
                    publicId:userPublicId,
                    academic_objective:'',
                    academic_gap_in_last_study_in_years:'',
                    academic_planning_for_how_many_years_more:'',
                    academic_is_finished:'',
                    academic_level:'',
                    academic_last_program_name:'',
                    academic_main_domain:'',
                    academic_sceondary_domain:'',
                    academic_last_institute_name:'',
                    academic_last_institute_website:'',
                    academic_last_institute_city:'',
                    academic_last_institute_country_id:'',
                    academic_finalize:'',
                    academic_finalize_year:'',
                    academic_finalize_date:new Date(),
                    academic_grade_scale:'',
                    academic_grade_scored:'',
                    academic_final_aim:'',
                    academic_attach_file:'',
                    academic_attach_file_path:'',
                    academic_attach_extra_certificate_path:'',
                    academic_attach_extra_certificate:'',
                }]
            })
        });
    }

    componentDidMount() {
        try {
            let user = JSON.parse(localStorage.getItem(USER_DATA));     
            this.setState({currentUser:user});
            this.setState({userAcademicInformation:[{publicId:user?.publicId,
                academic_objective:'',
                academic_gap_in_last_study_in_years:'',
                academic_planning_for_how_many_years_more:'',
                academic_is_finished:'',
                academic_level:'',
                academic_last_program_name:'',
                academic_main_domain:'',
                academic_sceondary_domain:'',
                academic_last_institute_name:'',
                academic_last_institute_website:'',
                academic_last_institute_city:'',
                academic_last_institute_country_id:'',
                academic_finalize:'',
                academic_finalize_year:'',
                academic_finalize_date:new Date(),
                academic_grade_scale:'',
                academic_grade_scored:'',
                academic_final_aim:'',
                academic_attach_file:'',
                academic_attach_extra_certificate:'',
            }]})
            this.getAllUniversity();
            this.getAllCountry();
            this.getCurrentUserAcademicInformation(user?.publicId);
        }
        catch(error){console.log(error)}
    }

    
    removeDocument(e, index, name) {
        console.log(name, 'name is:')
        if(name == "academic_attach_extra_certificate") { 
            this.state.userAcademicInformation[index]['academic_attach_extra_certificate']=''
            this.setState({userAcademicInformation:[...this.state.userAcademicInformation]})
        }
        else {
            this.state.userAcademicInformation[index]['academic_attach_file']='';
            this.setState({userAcademicInformation:[...this.state.userAcademicInformation]})
        }
    }

    
    render() {        
        return(
            <>
                <UserProfileBanner />
                <div className="accordion content-accordion" id="UserBiographicInformations">
                    <Row className="mb-4">
                        <Col className="text-end">
                            <Button className="btn-user-information btn btn-primary" onClick={this.appendFields}>+ Ajouter votre formation précédente</Button>
                        </Col>
                    </Row>
                    <div key='user_biographical_accordion' className="accordion-item bg-transparent">
                        <h2 className="accordion-header" id='heading'>
                            <button
                                className="accordion-button accordion-btn collapsed"
                                type="button" data-bs-toggle="collapse"
                                data-bs-target='#collapse'
                                aria-expanded="false" aria-controls='collapse'
                            >
                            Informations Académique
                            </button>
                        </h2>
                        <div
                            id='collapse'
                            className="accordion-collapse collapse show"
                            aria-labelledby='heading'
                            data-bs-parent="#UserBiographicInformations"
                        >
                            <div className="accordion-body p-0">
                                {/* {console.log(this.state.userAcademicInformation,'hello')} */}
                                <Form onSubmit={this.onSubmit}>
                                {
                                    this.state.userAcademicInformation && this.state.userAcademicInformation?.length >0 && this.state.userAcademicInformation?.map((fields, index) => (
                                        <div key={index} className="repeatedFields">
                                            {
                                                index == 0 &&
                                                <Row>
                                                    <Col>
                                                        <Form.Group controlId="academic_objective">
                                                            <Form.Label className="d-flex flex-wrap align-items-center justify-content-between user-information-label">
                                                                <strong>
                                                                    Mon objectif académique:
                                                                </strong>
                                                                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                                                                        <path d="M7 14C3.14 14 0 10.86 0 7C0 3.14 3.14 0 7 0C10.86 0 14 3.14 14 7C14 10.86 10.86 14 7 14ZM7 1C3.69 1 1 3.69 1 7C1 10.31 3.69 13 7 13C10.31 13 13 10.31 13 7C13 3.69 10.31 1 7 1Z" fill="#005073"/>
                                                                        <path d="M7 3.5C5.89 3.5 5 4.39 5 5.5H6C6 4.95 6.45 4.5 7 4.5C7.55 4.5 8 4.95 8 5.5C8 6.5 6.5 6.38 6.5 8H7.5C7.5 6.88 9 6.75 9 5.5C9 4.39 8.11 3.5 7 3.5Z" fill="#005073"/>
                                                                        <path d="M6.99988 10.62C7.3423 10.62 7.61988 10.3424 7.61988 10C7.61988 9.65759 7.3423 9.38 6.99988 9.38C6.65747 9.38 6.37988 9.65759 6.37988 10C6.37988 10.3424 6.65747 10.62 6.99988 10.62Z" fill="#005073"/>
                                                                        <path d="M5.5 6C5.77614 6 6 5.77614 6 5.5C6 5.22386 5.77614 5 5.5 5C5.22386 5 5 5.22386 5 5.5C5 5.77614 5.22386 6 5.5 6Z" fill="#005073"/>
                                                                        <path d="M7 8.5C7.27614 8.5 7.5 8.27614 7.5 8C7.5 7.72386 7.27614 7.5 7 7.5C6.72386 7.5 6.5 7.72386 6.5 8C6.5 8.27614 6.72386 8.5 7 8.5Z" fill="#005073"/>
                                                                    </svg>
                                                            </Form.Label>
                                                            <Form.Control as="textarea" name="academic_objective" onChange={(e)=>this.onChangeFields(e, index)} value={fields?.academic_objective} placeholder="example: Mon objectif est de poursuivre un doctorat en économie du développement dans un pays anglophone et me spécialiser en économie du développement" rows={4} style={{resize:'none'}} />
                                                        </Form.Group>
                                                    </Col>
                                                </Row>
                                            }
                                            {
                                            index == 0 &&
                                            <Row>
                                                <Col>
                                                    <Form.Group>
                                                        <Row>
                                                            <Col xs="12" sm="4">
                                                                <Form.Group controlId="academic_gap_in_last_study_in_years">
                                                                    <Form.Label className="d-flex flex-wrap align-items-center justify-content-between user-information-label">
                                                                        Combien d'années here
                                                                    </Form.Label>
                                                                    {
                                                                    this.state.academic_study_gap_year && this.state.academic_study_gap_year.length >0 && 
                                                                    <Form.Control as="select" required custom onChange={(e)=>this.onChangeFields(e, index)} name="academic_gap_in_last_study_in_years" value={fields && fields?.academic_gap_in_last_study_in_years}>
                                                                        {this.state.academic_study_gap_year?.map((gap_year)=>(<option key={gap_year?.id} value={gap_year?.year}>{gap_year?.year}</option>))}
                                                                    </Form.Control>
                                                                    }
                                                                </Form.Group>
                                                            </Col>
                                                            <Col xs="12" sm="8">
                                                                <Form.Group controlId="academic_planning_for_how_many_years_more">
                                                                    <Form.Label className="d-flex flex-wrap align-items-center justify-content-between user-information-label">
                                                                        Combien d'années d'études vous reste t-il poury parvenir?
                                                                    </Form.Label>
                                                                    {
                                                                    this.state.academic_planning_year && this.state.academic_planning_year.length >0 && 
                                                                    <Form.Control style={{maxWidth: '75%'}} as="select" required custom onChange={(e)=>this.onChangeFields(e, index)} name="academic_planning_for_how_many_years_more" value={fields && fields?.academic_planning_for_how_many_years_more}>
                                                                        {this.state.academic_planning_year?.map((planning_year)=>(<option key={planning_year?.id} value={planning_year?.year}>{planning_year?.year}</option>))}
                                                                    </Form.Control>
                                                                    }
                                                                </Form.Group>
                                                            </Col>
                                                        </Row>
                                                    </Form.Group>
                                                </Col>
                                            </Row>
                                            }

                                            <Row>
                                                <Col>
                                                    <Form.Group>
                                                        <Form.Label className="d-flex flex-wrap align-items-center justify-content-between user-information-label">
                                                            <strong>Merci de rajouter les informations relatives à cotre formation la plus récente. Vous pouvez ajouter ensuite, si vous le désirez jusqu'à deux formations antérieures (de la plus récente à la plus ancienne). Plus votre profil sera complet, meilleures seront vos chances d'identifier une opportunité qui vous correspond!</strong>
                                                        </Form.Label>
                                                        <Form.Check type="radio" label='Formation en cours' checked={fields && fields?.academic_is_finished == 'yes'} value='yes' className='radio-wrap d-inline-block' name={`academic_is_finished_${index}`} id={`academic_is_finished_yes_${index}`} onChange={(e)=>this.onChangeFields(e, index)} />
                                                        <Form.Check type="radio" label='Formation finalisée' checked={fields && fields?.academic_is_finished == 'no'} value='no' className='radio-wrap d-inline-block ml-4' name={`academic_is_finished_${index}`} id={`academic_is_finished_no_${index}`} onChange={(e)=>this.onChangeFields(e, index)} />
                                                    </Form.Group>
                                                </Col>
                                            </Row>


                                            <Row>
                                                <Col>
                                                    <Form.Group>
                                                        <Row>
                                                            <Col xs="12" sm="3">
                                                            
                                                                <Form.Group controlId="academic_level">
                                                                    <Form.Label className="d-flex flex-wrap align-items-center justify-content-between user-information-label">
                                                                        Niveau
                                                                    </Form.Label>
                                                                    {
                                                                    this.state.academic_level && this.state.academic_level.length >0 && 
                                                                    <Form.Control as="select" required custom onChange={(e)=>this.onChangeFields(e, index)} name="academic_level" value={fields && fields?.academic_level}>
                                                                        {this.state.academic_level?.map((level)=>(<option key={level?.value} value={level?.label}>{level?.label}</option>))}
                                                                    </Form.Control>
                                                                    }
                                                                </Form.Group>
                                                            </Col>
                                                            <Col xs="12" sm="3">
                                                                <Form.Group controlId="academic_last_program_name">
                                                                    <Form.Label className="d-flex flex-wrap align-items-center justify-content-between user-information-label">
                                                                        Nom du programme
                                                                    </Form.Label>
                                                                    {
                                                                    this.state.academic_programme && this.state.academic_programme.length >0 && 
                                                                    <Form.Control as="select" required custom onChange={(e)=>this.onChangeFields(e, index)} name="academic_last_program_name" value={fields && fields?.academic_last_program_name}>
                                                                        {this.state.academic_programme?.map((programme)=>(<option key={programme?.value} value={programme?.label}>{programme?.label}</option>))}
                                                                    </Form.Control>
                                                                    }
                                                                </Form.Group>
                                                            </Col>
                                                            <Col xs="12" sm="3">
                                                                <Form.Group controlId="academic_main_domain">
                                                                    <Form.Label className="d-flex flex-wrap align-items-center justify-content-between user-information-label">
                                                                        Domaine principal
                                                                    </Form.Label>
                                                                    {
                                                                    this.state.academic_main_domain && this.state.academic_main_domain.length >0 && 
                                                                    <Form.Control as="select" required custom onChange={(e)=>this.onChangeFields(e, index)} name="academic_main_domain" value={fields && fields?.academic_main_domain}>
                                                                        {this.state.academic_main_domain?.map((main_domain)=>(<option key={main_domain?.value} value={main_domain?.label}>{main_domain?.label}</option>))}
                                                                    </Form.Control>
                                                                    }
                                                                </Form.Group>
                                                            </Col>
                                                            <Col xs="12" sm="3">
                                                                <Form.Group controlId="academic_sceondary_domain">
                                                                    <Form.Label className="d-flex flex-wrap align-items-center justify-content-between user-information-label">
                                                                        Domaine secondaire
                                                                    </Form.Label>
                                                                    {
                                                                    this.state.academic_sceondary_domain && this.state.academic_sceondary_domain.length >0 && 
                                                                    <Form.Control as="select" required custom onChange={(e)=>this.onChangeFields(e, index)} name="academic_sceondary_domain" value={fields && fields?.academic_sceondary_domain}>
                                                                        {this.state.academic_sceondary_domain?.map((secondary_domain)=>(<option key={secondary_domain?.value} value={secondary_domain?.label}>{secondary_domain?.label}</option>))}
                                                                    </Form.Control>
                                                                    }
                                                                </Form.Group>
                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                            <Col xs="12" sm="3">
                                                            </Col>
                                                            <Col xs="12" sm="9">
                                                                <Form.Group controlId="identify_cases">
                                                                    <Form.Control type="text" placeholder="Text box for others" />
                                                                </Form.Group>
                                                            </Col>
                                                        </Row>
                                                    </Form.Group>
                                                </Col>
                                            </Row>
                                            
                                            <Row>
                                                <Col>
                                                    <Form.Group>
                                                        <Row>
                                                            <Col xs="12" sm="3">
                                                                <Form.Group controlId="academic_last_institute_name">
                                                                    <Form.Label className="d-flex flex-wrap align-items-center justify-content-between user-information-label">
                                                                        Nom de l’Institution
                                                                    </Form.Label>
                                                                    {
                                                                    this.state.getAllUniversity && this.state.getAllUniversity.length >0 && 
                                                                    <Form.Control as="select" required custom onChange={(e)=>this.onChangeFields(e, index)} name="academic_last_institute_name" value={fields && fields?.academic_last_institute_name}>
                                                                        {this.state.getAllUniversity?.map((university)=>(<option key={university?.id} value={university?.name}>{university?.name}</option>))}
                                                                    </Form.Control>
                                                                    }
                                                                </Form.Group>
                                                            </Col>
                                                            <Col xs="12" sm="6">
                                                                <Form.Group controlId="academic_last_institute_website">
                                                                    <Form.Label className="d-flex flex-wrap align-items-center user-information-label">
                                                                        Site Internet <span style={{color: '#828282', fontSize:'12px', letterSpacing: '0.3px', display:'inline-block', marginLeft: '5px'}}>(Optional)</span>
                                                                    </Form.Label>
                                                                    <Form.Group controlId="academic_last_institute_website">
                                                                        <Form.Control type="url" placeholder="Text box for others" name="academic_last_institute_website" value={fields && fields?.academic_last_institute_website} onChange={(e)=>this.onChangeFields(e, index)} />
                                                                    </Form.Group>
                                                                </Form.Group>
                                                            </Col>
                                                            <Col xs="12" sm="3">
                                                                <Form.Group controlId="academic_last_institute_city">
                                                                    <Form.Label className="d-flex flex-wrap align-items-center justify-content-between user-information-label">
                                                                        Ville
                                                                    </Form.Label>
                                                                    {
                                                                    this.state.institute_city && this.state.institute_city.length >0 && 
                                                                    <Form.Control as="select" required custom onChange={(e)=>this.onChangeFields(e, index)} name="academic_last_institute_city" value={fields && fields?.academic_last_institute_city}>
                                                                        {this.state.institute_city?.map((city)=>(<option key={city?.value} value={city?.label}>{city?.label}</option>))}
                                                                    </Form.Control>
                                                                    }
                                                                </Form.Group>
                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                            <Col xs="12">
                                                                <Form.Group controlId="identify_cases">
                                                                    <Form.Control type="text" placeholder="Text box for others" />
                                                                </Form.Group>
                                                            </Col>
                                                        </Row>
                                                    </Form.Group>
                                                </Col>
                                            </Row>
                                        
                                            <Row>
                                                <Col xs="12" sm="4">
                                                    <Form.Group controlId="academic_last_institute_country_id">
                                                        <Form.Label className="d-flex flex-wrap align-items-center justify-content-between user-information-label">
                                                            Pays
                                                        </Form.Label>
                                                        {
                                                            this.state.getAllCountry && this.state.getAllCountry.length >0 && 
                                                            <Form.Control as="select" required custom onChange={(e)=>this.onChangeFields(e, index)} name="academic_last_institute_country_id" value={fields && fields?.getAllCountry}>
                                                                {this.state.getAllCountry?.map((country)=>(<option key={country?.id} value={country?.name}>{country?.name}</option>))}
                                                            </Form.Control>
                                                        }
                                                    </Form.Group>
                                                </Col>
                                                <Col xs="12" sm="4">
                                                {/* {console.log(fields?.academic_finalize, 'data is')} */}
                                                    <Form.Group controlId="academic_finalize">
                                                        <Form.Label className="d-flex flex-wrap align-items-center justify-content-between user-information-label">
                                                            Avez-vous finalisé votre année?
                                                        </Form.Label>
                                                        {
                                                            <Form.Control as="select" required custom onChange={(e)=>this.onChangeFields(e, index)} name="academic_finalize" value={fields && fields?.academic_finalize}>
                                                                <option value="yes">Yes</option>
                                                                <option value="No">No</option>
                                                            </Form.Control>
                                                        }
                                                    </Form.Group>
                                                </Col>
                                                <Col xs="12" sm="4">
                                                    <Form.Group controlId="academic_finalize_date">
                                                        <Form.Label className="d-flex flex-wrap align-items-center justify-content-between user-information-label">
                                                            Date de finalisation du programme
                                                        </Form.Label>
                                                        {/* <DatePicker showIcon selected={fields && fields?.academic_finalize_date ? moment(fields?.academic_finalize_date).toDate():fields?.academic_finalize_date} onChange={(date) => this.dateChange(date, index)} name="academic_finalize_date" /> */}
                                                    </Form.Group>
                                                </Col>
                                            </Row>

                                            <Row>
                                                <Col xs="12" sm="3">
                                                    <Form.Group controlId="academic_grade_scale">
                                                        <Form.Label className="d-flex flex-wrap align-items-center justify-content-between user-information-label">
                                                            Type d'échelle de notes
                                                        </Form.Label>
                                                        {
                                                            this.state.grade && this.state.grade.length >0 && 
                                                            <Form.Control as="select" required custom onChange={(e)=>this.onChangeFields(e, index)} name="academic_grade_scale" value={fields && fields?.academic_grade_scale}>
                                                                {this.state.grade?.map((scale)=>(<option key={scale?.id} value={scale?.grade}>{scale?.grade}</option>))}
                                                            </Form.Control>
                                                        }
                                                    </Form.Group>
                                                </Col>
                                                <Col xs="12" sm="3">
                                                    <Form.Group controlId="academic_grade_scored">
                                                        <Form.Label className="d-flex flex-wrap align-items-center justify-content-between user-information-label">
                                                            Échelle
                                                        </Form.Label>
                                                        {
                                                            this.state.grade_scored && this.state.grade_scored.length >0 && 
                                                            <Form.Control as="select" required custom onChange={(e)=>this.onChangeFields(e, index)} name="academic_grade_scored" value={fields && fields?.academic_grade_scored}>
                                                                {this.state.grade_scored?.map((scored)=>(<option key={scored?.id} value={scored?.grade}>{scored?.grade}</option>))}
                                                            </Form.Control>
                                                        }
                                                    </Form.Group>
                                                </Col>
                                                <Col xs="12" sm="6">
                                                    <Form.Group controlId="academic_final_aim">
                                                        <Form.Label className="d-flex flex-wrap align-items-center justify-content-between user-information-label">
                                                            Quel niveau d'études final visez-vous?
                                                        </Form.Label>
                                                        {
                                                            this.state.getAllUniversity && this.state.getAllUniversity.length >0 && 
                                                            <Form.Control as="select" required custom onChange={(e)=>this.onChangeFields(e, index)} name="academic_final_aim" value={fields && fields?.academic_final_aim}>
                                                                {this.state.getAllUniversity?.map((university)=>(<option key={university?.id} value={university?.name}>{university?.name}</option>))}
                                                            </Form.Control>
                                                        }
                                                    </Form.Group>
                                                </Col>
                                            </Row>

                                            <Row>
                                                <Col xs="12" sm="8">
                                                    <Row className="m-0 mb-4 align-items-end">
                                                        <Col xs="6" className="p-0">
                                                            <Form.Group className="position-relative file-group mb-0">
                                                                <Form.Label className="d-flex flex-wrap align-items-center justify-content-between user-information-label">                                                                
                                                                    Merci de joindre vos notes
                                                                </Form.Label>
                                                                <Form.Control type="text" defaultValue={this.state.academic_attach_file?.name ? this.state.academic_attach_file?.name : ''} name="file_upload" id="file_upload"></Form.Control>
                                                            </Form.Group>
                                                        </Col>
                                                        <Col xs="12" md="6" className="p-0 ps-2 academic_attachment">
                                                            <Form.File id={`academic_attach_file_${index}`} label="Upload" name="academic_attach_file" onChange={(e)=>{
                                                                this.uploadUserDocuments(e, index)
                                                            }} />
                                                        </Col>
                                                        {
                                                            fields && fields?.academic_attach_file !="" && 
                                                            <Col xs="12" md="6" className="p-0 ps-2 academic_attachment mt-2">
                                                                <a target="_blank" href={WEBSITE_URL + '/' + fields?.academic_attach_file_path + '' + fields?.academic_attach_file} style={{fontSize:'12px'}}>
                                                                    <i className='bx bx-download'></i> Download File
                                                                </a>
                                                                <i className='bx bx-trash' style={{color:"#ff0000", marginLeft: '5px'}} onClick={(e)=>this.removeDocument(e, index, 'academic_attach_file')}></i>
                                                            </Col>
                                                        }
                                                        {
                                                            fields && fields?.uploadedDocumentStatusAttach && fields?.uploadedDocumentStatusAttach?.message && 
                                                            <div className="text-danger mt-2 user-information-label">Attachment allowed pdf,doc,docx</div>
                                                        }
                                                    </Row>
                                                </Col>
                                            </Row>

                                            <Row>
                                                <Col xs="12" sm="6" className="mb-3">
                                                    {/* {console.log(fields?.enable_extra_certificates, 'fields?.academic_attach_extra_certificate')} */}
                                                    {/* checked={fields?.academic_attach_extra_certificate != "" ? 'checked' : fields?.enable_extra_certificates ? true : false} */}
                                                    <Form.Check inline type='checkbox' checked={fields?.enable_extra_certificates=='true'?'checked':''} value={fields?.enable_extra_certificates == 'true' ? false : true} name="enable_extra_certificates" id={`enable_extra_certificates_${index}`} onChange={(e)=>this.onChangeFields(e, index)} label="Je n'ai pas encore reçu de certificat/attestation de réussite ou mon diplôme" />
                                                </Col>
                                            </Row>

                                            <Row>
                                                <Col xs="12" sm="7">
                                                {
                                               fields?.enable_extra_certificates == 'true' ?
                                                        <Row className="m-0 align-items-end">
                                                            <Col xs="8" className="p-0">
                                                                <Form.Group className="position-relative file-group mb-0">
                                                                    <Form.Label className="d-flex flex-wrap align-items-center justify-content-between user-information-label">
                                                                        Attestation de réussite (Optional)
                                                                    </Form.Label>
                                                                    <Form.Control type="text" name="file_upload" id="file_upload" defaultValue={this.state.academic_attach_extra_certificate?.name ? this.state.academic_attach_extra_certificate?.name : ''}></Form.Control>
                                                                </Form.Group>
                                                            </Col>
                                                            <Col xs="12" md="4" className="p-0 ps-2 academic_attachment">
                                                                <Form.File id={`academic_attach_extra_certificate${index}`} label="Upload" name="academic_attach_extra_certificate" onChange={
                                                                    (e)=>this.uploadUserDocuments(e, index)
                                                                } />
                                                            </Col>
                                                            {
                                                            fields && fields?.academic_attach_extra_certificate !="" && 
                                                            <Col xs="12" md="6" className="p-0 ps-2 academic_attachment mt-2">
                                                                <a target="_blank" href={WEBSITE_URL + '/' + fields?.academic_attach_extra_certificate_path + '' + fields?.academic_attach_extra_certificate} style={{fontSize:'12px'}}>
                                                                    <i className='bx bx-download'></i> Download File
                                                                </a>
                                                                <i className='bx bx-trash' style={{color:"#ff0000", marginLeft: '5px'}} onClick={(e)=>this.removeDocument(e, index, 'academic_attach_extra_certificate')}></i>
                                                            </Col>
                                                        }
                                                        {
                                                            fields && fields?.uploadedDocumentStatusExtraAttach && fields?.uploadedDocumentStatusExtraAttach?.message && 
                                                            <div className="text-danger mt-2 user-information-label">Attachment allowed pdf,doc,docx</div>
                                                        }
                                                        </Row>
                                                        :''
                                                }
                                                </Col>
                                            </Row>
                                        </div>
                                    ))
                                    }
                                    <Row>
                                        <Col xs="12" sm="7"></Col>
                                        <Col xs="12" sm="5" className="align-items-end d-flex justify-content-end">
                                            <Button className="btn-user-information" type="submit">Sauver et poursuivre</Button>
                                        </Col>
                                    </Row>
                                    
                                </Form>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}
export default UserAcademicInformation;